var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTriangleWarninglarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.75a.76.76 0 0 1-.75-.75V9c0-.41.34-.75.75-.75s.75.34.75.75v5c0 .41-.34.75-.75.75ZM12 18a1.5 1.5 0 0 1-.2-.02.64.64 0 0 1-.18-.06.76.76 0 0 1-.18-.09l-.15-.12A1.05 1.05 0 0 1 11 17c0-.26.11-.52.29-.71l.15-.12a.76.76 0 0 1 .18-.09.86.86 0 0 1 .57-.06.6.6 0 0 1 .19.06l.18.09.15.12c.18.19.29.45.29.71 0 .26-.11.52-.29.71l-.15.12a.76.76 0 0 1-.18.09.6.6 0 0 1-.19.06L12 18Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.06 22.16H5.94c-1.95 0-3.44-.71-4.2-1.99-.75-1.28-.65-2.93.3-4.64L8.1 4.63c1-1.8 2.38-2.79 3.9-2.79s2.9.99 3.9 2.79l6.06 10.91c.95 1.71 1.06 3.35.3 4.64-.76 1.27-2.25 1.98-4.2 1.98ZM12 3.34c-.94 0-1.86.72-2.59 2.02L3.36 16.27c-.68 1.22-.79 2.34-.32 3.15.47.81 1.51 1.25 2.91 1.25h12.12c1.4 0 2.43-.44 2.91-1.25s.36-1.92-.32-3.15L14.59 5.36c-.73-1.3-1.65-2.02-2.59-2.02Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleWarninglarge);
export default __webpack_public_path__ + "static/media/triangleWarning.large.2a0c552e053550d307e18be1a4c5bb6a.svg";
export { ForwardRef as ReactComponent };